import { Component, OnInit, Injectable } from '@angular/core';
import * as d3 from "d3";
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from '../../services/session.service';
import { ValidationsService } from '../../services/validations.service';
import { CatalogosService } from '../../services/catalogos.service';
import { environment } from '../../../environments/environment';
import { EmitterVisitorContext } from '@angular/compiler';

@Component({
  selector: 'app-recursos-federales',
  templateUrl: './recursos-federales.page.html',
  styleUrls: ['./recursos-federales.page.scss']
})
@Injectable({
  providedIn: 'root'
})
export class RecursosFederalesPage implements OnInit {
  loading: any = false;
  hasSession: any = false;

  processed_data: any = [];
  local_indicators: any = {};

  localRoute: any = {
    _value: null
  };

  public metrics: any = [];
  public dimensions: any = [];

  data: any = {
    complete: false,
    metrics: [""],
    dimensions: [""],
    map: false,
    payload: []
  }

  public navCtrlr: any = [
    { id: 0, title: "Grafícas", src_img: "assets/images/icon-cdmx-chart.svg", active: false },
    { id: 1, title: "Mapa", src_img: "assets/images/icon-cdmx-map.svg", active: false },
    { id: 2, title: "Información", src_img: "assets/images/icon-cdmx-info.svg", active: true }
  ];

  constructor(
    public route: Router,
    private router: ActivatedRoute,
    private catalogosService: CatalogosService
  ) {
    this.localRoute = this.router.queryParams;
    console.log("localRoute ==> ", this.localRoute);

    console.log("metric => ", this.localRoute._value.metrics.split(","));
    this.processIncoming(this.localRoute)
    // TODO get var from URL, set metrics & dimensions
    // Also could recive the active menu / aka charts to plot
  }

  async ngOnInit() {
    // Validate if session is active and exists
    const controller = this;

    this.loading = true;

    // Abstract service to call, depends on the queryParams
    this.catalogosService.getFederalResources()
      .then(async (res) => {
        // Todo Abstract var sent to data processor
        // let payload = res ? await controller.processData(res, controller.data.metrics, controller.data.dimensions) : [];
        controller.data.payload = res ? await controller.processData(res, controller.data.metrics, controller.data.dimensions) : [];
        controller.data.complete = true;

        // TODO this is dumb
        this.data = {
          metrics: controller.data.metrics,
          dimensions: controller.data.dimensions,
          map: controller.data.map,
          payload: res ? await controller.processData(res, controller.data.metrics, controller.data.dimensions) : [],
          complete: true
        }

        console.log("DATA )> ", this.data);

      });
    this.loading = false;
  }

  private async processIncoming(route: any) {
    const controller = this;
    let obj: any = route._value;
    // let keys: any = Object.key(obj); // metrics
    console.log("OBJS => ", obj);

    let vals = [];
    for (const prop in obj) {
      // console.log("prop ==> ", prop)

      switch (prop) {
        case "metrics":
          controller.data.metrics = obj[prop].split(",");
          break;
        case "dimensions":
          controller.data.dimensions = obj[prop].split(",");
          break;
        case "mode":
          console.log("route => ", obj[prop]);
          break;
        case "map":
          // console.log("route => ", obj[prop]);
          controller.data.map = obj[prop];
          break;
        default:
          break;
      }
        // vals.push(obj[prop]);
    }
    console.log("DATA => ", controller.data);

    // TODO get metric
  }

  private async processData(data: any, metrics: any, dimensions: any) {
    // ciclo is part of the object, how to abstract?
    let proccessed_data: any = [];
    await metrics.map(async (single_data) => {
      let groupByMetric = [...new Set(data.filters.map(item => item[single_data]))];
      let groupedMetric: any = [];

      // groupByMetric.sort((a, b) => a.metric - b.metric);
      //
      await groupByMetric.map((metric) => {
        groupedMetric.push({ metric: metric, data: data.filters.filter(el => el[single_data] == metric) });
      });
      proccessed_data.push({ item: single_data, group: groupedMetric });
    });

    // proccessed_data.sort((a, b) => a.metric - b.metric);

    return proccessed_data;
  }

}
